import {
  GET_RESERVATION_CART_SUCCESS,
  GET_RESERVATION_CART_OBJECT_REQUESTING,
  RESET_RESERVATION_CART_ISFETCHING,
  MOBILE_RESERVATION_CART_SUMMARY_VISIBLE,
  MOBILE_RESERVATION_CART_SUMMARY_NOT_VISIBLE
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false,
  isMobileReservationSummaryVisible: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_RESERVATION_CART_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false
      };
    }
    case GET_RESERVATION_CART_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case GET_RESERVATION_CART_SUCCESS: {
      const virtualCart = state.data?.virtualCart;
      const data = action.payload;

      if (!action.payload.virtualCart && virtualCart) {
        data.virtualCart = virtualCart;
      }

      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case MOBILE_RESERVATION_CART_SUMMARY_VISIBLE: {
      return {
        ...state,
        isMobileReservationSummaryVisible: true
      };
    }
    case MOBILE_RESERVATION_CART_SUMMARY_NOT_VISIBLE: {
      return {
        ...state,
        isMobileReservationSummaryVisible: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
